import { defineChain } from 'viem'

export const defiVerse = defineChain({
  id: 16116,
  name: 'DeFiVerse',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.defi-verse.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'DeFiVerse Explorer',
      url: 'https://scan.defi-verse.org',
      apiUrl: 'https://scan.defi-verse.org/api',
    },
  },
  testnet: false,
})
